import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {ISickDay} from '@app/core/interfaces/sick-days.interface';
import {EQORebrandColor, EQORebrandIcon} from '@quickorder/angular-web-lib';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {RespondSickDay} from '@app/core/store/actions/sick-days.actions';
import {Observable} from 'rxjs';
import {selectIsSickDaysLoading} from '@app/core/store/selectors/sick-days.selectors';

@Component({
	selector: 'app-sick-day-answer-employee',
	templateUrl: './sick-day-answer-employee.component.html',
	styleUrls: ['./sick-day-answer-employee.component.scss'],
})
export class SickDayAnswerEmployeeComponent {
	public EQORebrandIcon: typeof EQORebrandIcon = EQORebrandIcon;
	public EQORebrandColor: typeof EQORebrandColor = EQORebrandColor;
	public isLoading$: Observable<boolean> = this.store.select(selectIsSickDaysLoading);

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { sickDay: ISickDay },
		private store: Store<IAppState>,
		private dialog: MatDialog,
	) {
	}

	public respond(response: boolean): void {
		this.store.dispatch(new RespondSickDay(this.data.sickDay, response));
	}

	public close(): void {
		this.dialog.getDialogById('employeeSickDayAnswerDlg')?.close();
	}
}
